const anime = require("animejs");
const router = require("services/router");

function chat(parentContainer = document, className = "chat") {

    const dots = document.querySelectorAll('.dot');
    const chat = document.getElementsByClassName("teacher-chat");

    if (typeof(chat[0]) == 'undefined' && chat[0] == null) {
        return;
    }

    anime.timeline({
        targets: dots,
        loop: true
    })
    .add({
        translateY: ['0', '20'],
        scale: ['1', '0.5'],
        duration: function(el, i, l) {
            return 500 + (i * 500);
        },
        delay: function(el, i, l) {
            return i * 300;
        },
        elasticity: function(el, i, l) {
            return (200 + i * 200);
        }
    })
    .add({
        targets: dots,
        translateY: ['-20', '0'],
        scale: ['0.5', '1'],
        duration: function(el, i, l) {
            return 500 + (i * 500);
        },
        delay: function(el, i, l) {
            return i * 300;
        },
        elasticity: function(el, i, l) {
            return (200 + i * 200);
        },
        offset: '-=1000'
    });

    // function emojiCatch(str){

    //     //targeted smielies and replacements    
    //     const happy = "<span class='emoji' style='background: url(../img/emojis/happy.png);'></span>";
    //     let targets = {
    //         ":-)": "<span class='emoji' style='background: url("+router.url("img/emojis/slight-happy.png")+");'></span>",
    //         ":)": "<span class='emoji' style='background: url("+router.url("img/emojis/slight-happy.png")+");'></span>",
    //         ":-(": "<span class='emoji' style='background: url("+router.url("img/emojis/sad.png")+");'></span>",
    //         ":(": "<span class='emoji' style='background: url("+router.url("img/emojis/sad.png")+");'></span>",
    //         ":-/": "<span class='emoji' style='background: url("+router.url("img/emojis/skew.png")+");'></span>",
    //         ":/": "<span class='emoji' style='background: url("+router.url("img/emojis/skew.png")+");'></span>",
    //         ":-D": happy,
    //         ":D": happy
    //     };


    //     function replacer(match, p1, p2, p3, offset, string) {

    //         return targets[match];
    //     }

    //     let regMatch = "";

    //     for (var target in targets) {

    //         console.log(target);

    //         target = target.replace(/(\)|\(|\/)/g, "\\$1");

    //         regMatch += target +"|";
            
    //     }

    //     regMatch = regMatch.substring(0, regMatch.length - 1);

    //     var regex = new RegExp("(" + regMatch + ")", "g");

    //     return str.replace(regex, replacer);

    // }

    // function setEndOfContenteditable(contentEditableElement)
    // {
    //     var range,selection;
    //     if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    //     {
    //         range = document.createRange();//Create a range (a range is a like the selection but invisible)
    //         range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
    //         range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
    //         selection = window.getSelection();//get the selection object (allows you to change selection)
    //         selection.removeAllRanges();//remove any selections already made
    //         selection.addRange(range);//make the range you have just created the visible selection
    //     }
    //     else if(document.selection)//IE 8 and lower
    //     { 
    //         range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
    //         range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
    //         range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
    //         range.select();//Select the range (make it the visible selection
    //     }
    // }

    // document.getElementById('msgInput').addEventListener("keyup", function(e){
    //     if(e.keyCode == 32){
    //         var str = this.innerHTML;
    //         var result = emojiCatch(str);
    //         this.innerHTML = result;
    //         setEndOfContenteditable(this);
    //     }
    // });

}

module.exports = chat;


// WEBPACK FOOTER //
// ./resources/js/modules/chat.js